var map = {
	"./map1.jpg": "BhHe",
	"./map1_relation.jpg": "Puv/",
	"./map2.jpg": "sYR9",
	"./map2_relation.jpg": "aO1d",
	"./map3.jpg": "NzZ6",
	"./map3_relation.jpg": "vUzK",
	"./map4.jpg": "Tl0B",
	"./map4_relation.jpg": "5JeJ",
	"./map5.jpg": "iZih",
	"./map5_relation.jpg": "/dnd",
	"./map6.jpg": "BEsd",
	"./map6_relation.jpg": "NoFK",
	"./map7.jpg": "zRa6",
	"./map7_relation.jpg": "zN5b",
	"./map8.jpg": "4aEZ",
	"./map8_relation.jpg": "qOIi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "icyN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/map.*\.jpg$
// module id = icyN
// module chunks = 1